export const base = 'descriptive-analysis-pj';

export const descriptiveAnalysis = `${base}/all-descriptive-analysis`;
